export default "__VITE_ASSET__BQ7fYv4v__"